import { Vector3, ColorPointCollection, pointToHSL, hslToPoint } from './poline';

export class ColorPoint {
  public x = 0;

  public y = 0;

  public z = 0;

  public color: Vector3 = [0, 0, 0];

  private _invertedLightness = false;

  constructor({ xyz, color, invertedLightness = false }: ColorPointCollection = {}) {
    this._invertedLightness = invertedLightness;
    this.positionOrColor({ xyz, color, invertedLightness });
  }

  positionOrColor({ xyz, color, invertedLightness = false }: ColorPointCollection) {
    if ((xyz && color) || (!xyz && !color)) {
      throw new Error('Point must be initialized with either x,y,z or hsl');
    } else if (xyz) {
      [this.x, this.y, this.z] = xyz;
      this.color = pointToHSL([this.x, this.y, this.z], invertedLightness);
    } else if (color) {
      this.color = color;
      [this.x, this.y, this.z] = hslToPoint(color, invertedLightness);
    }
  }

  set position([x, y, z]: Vector3) {
    this.x = x;
    this.y = y;
    this.z = z;
    this.color = pointToHSL([this.x, this.y, this.z] as Vector3, this._invertedLightness);
  }

  get position(): Vector3 {
    return [this.x, this.y, this.z];
  }

  set hsl([h, s, l]: Vector3) {
    this.color = [h, s, l];
    [this.x, this.y, this.z] = hslToPoint(this.color as Vector3, this._invertedLightness);
  }

  get hsl(): Vector3 {
    return this.color;
  }

  get hslCSS(): string {
    const [h, s, l] = this.color;
    return `hsl(${h.toFixed(2)}, ${(s * 100).toFixed(2)}%, ${(l * 100).toFixed(2)}%)`;
  }

  get oklchCSS(): string {
    const [h, s, l] = this.color;
    return `oklch(${(l * 100).toFixed(2)}% ${(s * 0.4).toFixed(3)} ${h.toFixed(2)})`;
  }

  get lchCSS(): string {
    const [h, s, l] = this.color;
    return `lch(${(l * 100).toFixed(2)}% ${(s * 150).toFixed(2)} ${h.toFixed(2)})`;
  }

  shiftHue(angle: number): void {
    this.color[0] = (360 + (this.color[0] + angle)) % 360;
    [this.x, this.y, this.z] = hslToPoint(this.color as Vector3, this._invertedLightness);
  }
}
